import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, toImage } from "../util.js"

rendererResolvers.push(
	({ toRel, item }) => {
		if (item != Item.THRUSTER_STARTER)
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				const img = await getImage("thruster_starter")

				const canvas = createCanvas(img.height - 38, img.width)
				const ctx = canvas.getContext("2d")

				ctx.rotate(-90 * (Math.PI / 180))
				ctx.drawImage(img, -40, -38)

				return [{
					image: await toImage(canvas),
					texturePosOff: toRel(-2, 0),
					textureSizeOff: toRel(42, 0),
					baseBoundOff: { x: 0.2, y: 0.2 }
				}]
			}
		}
	}
)
